__turbopack_context__.v({
  "answer-container": "styles-module-scss-module__7X-fNq__answer-container",
  "qa-container": "styles-module-scss-module__7X-fNq__qa-container",
  "qa-letter-icon": "styles-module-scss-module__7X-fNq__qa-letter-icon",
  "question": "styles-module-scss-module__7X-fNq__question",
});
